import React from 'react';

const ChatSkeleton = () => (
  <div className="mp-chat-skeleton" aria-hidden>
    <div className="mp-chat-skeleton__header" />
    <div className="mp-chat-skeleton__product" />
    <div className="mp-chat-skeleton__messages">
      <div className="mp-chat-skeleton__bubble mp-chat-skeleton__bubble--left" />
      <div className="mp-chat-skeleton__bubble mp-chat-skeleton__bubble--right" />
      <div className="mp-chat-skeleton__bubble mp-chat-skeleton__bubble--left" />
      <div className="mp-chat-skeleton__card" />
    </div>
    <div className="mp-chat-skeleton__composer" />
  </div>
);

export default ChatSkeleton;
